module.exports = __webpack_public_path__ + "img/popup-promo.f327e6a0.jpg";